export function defineSubappRoutes(definitions) {
  // routes get injecter into rudy
  const routes = {}

  // pages get injected into constants
  const pages = {}

  // handlers get injected into page reducers
  const handlers = {}

  definitions.forEach(definition => {
    pages[definition.page] = definition.page
    routes[definition.page] = definition.route
    handlers[definition.page] = definition.handler
  })

  return {
    routes,
    pages,
    handlers,
    registerPageReducer: registerPageReducer => {
      definitions.forEach(definition =>
        registerPageReducer(definition.page, definition.handler)
      )
    },
  }
}
